<template>
  <span
    class="campanha-status-badge"
    :style="{ backgroundColor: config.badgeColor }"
  >
    {{ config.label }}
  </span>
</template>

<script>
import { getStatusConfig } from "../helpers/campanhaStatus";

export default {
  name: "CampanhaStatusBadge",
  props: {
    campanha: {
      type: Object,
      required: true,
    },
  },
  computed: {
    config() {
      return getStatusConfig(this.campanha);
    },
  },
};
</script>

<style scoped>
.campanha-status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  line-height: 1.4;
}
</style>
